<template>
    <v-sheet color="grey lighten-3" class="pa-6">
        <v-row align="start">
            <v-col cols="12" md="4">
                <v-card-title class="pa-0">
                    <v-select v-model="form.price.unit" solo flat hide-details v-bind="{ items: units }" @input="emit" />
                </v-card-title>
            </v-col>
            <v-col cols="12" md="8" class="purchase-amount__form">
                <v-row class="ma-n1">
                    <v-col class="pa-1" cols="12">
                        <v-row class="ma-n1" justify="end" align="center">
                            <v-col class="pa-1" cols="auto">
                                <v-btn icon tile @click="decrease"> <v-icon> mdi-minus </v-icon> </v-btn>
                            </v-col>
                            <v-col class="pa-1" cols="auto">
                                <v-text-field class="purchase-amount__form__data" v-model="form.count" type="number" flat solo hide-details @input="emit" />
                            </v-col>
                            <v-col class="pa-1" cols="auto">
                                <v-btn icon tile @click="increase(1)"> <v-icon> mdi-plus </v-icon> </v-btn>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col class="pa-1" cols="12">
                        <v-row class="ma-n1" justify="end" align="center">
                            <template v-for="value in [5, 10, 20, 40]">
                                <v-col class="pa-1" cols="auto" :key="value">
                                    <v-btn x-small @click="increase(value)"> +{{ value }}개 </v-btn>
                                </v-col>
                            </template>
                        </v-row>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-sheet>
</template>

<script>
import { initNshopOrder, NshopOrderAider } from "@/store/nshop";

/** @typedef {import('@/store/nshop').NshopOrder} NshopOrder */

const units = [
    {
        text: "50,000원권",
        value: 50000,
    },
    {
        text: "30,000원권",
        value: 30000,
    },
    {
        text: "10,000원권",
        value: 10000,
    },
];

export default {
    components: {},
    props: {
        /** @type {import('vue').PropType<NshopOrder>} */
        value: { type: Object, default: initNshopOrder },
    },
    data: () => ({
        form: initNshopOrder(),

        units,
    }),
    computed: {
        min() {
            return NshopOrderAider.calcCountMin(this.form);
        },
        max() {
            return NshopOrderAider.calcCountMax(this.form);
        },
    },
    methods: {
        sync() {
            this.form = initNshopOrder(this.value);
            if (this.max < this.form.count) {
                this.form.count = this.max;
                this.emit();
            }
        },
        emit() {
            let { ...form } = this.form;

            if (form.count < this.min) form.count = this.min;
            if (this.max < form.count) form.count = this.max;

            form.price = NshopOrderAider.calcPrice(form);

            this.$emit("input", form);
        },

        decrease() {
            this.form.count -= 1;
            this.emit();
        },
        increase(value = 1) {
            this.form.count += value;
            this.emit();
        },
    },
    watch: {
        value() {
            this.sync();
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style lang="scss" scoped>
.purchase-amount {
    &__form {
        &__data {
            max-width: 80px;

            & ::v-deep input {
                text-align: center;

                &::-webkit-outer-spin-button,
                &::-webkit-inner-spin-button {
                    -webkit-appearance: none;
                    margin: 0;
                }

                &[type="number"] {
                    -moz-appearance: textfield;
                    appearance: textfield;
                }
            }
        }
    }
}
</style>
